// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-main-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: 100%;
  padding: 2em;
  flex: 1 1;
}

.dropdown-list {
  background-color: #fff;
  border-radius: 1em;
  margin-inline: 2em;
  padding: 2em;
  flex: 1 1;
  width: 100%;
}
.dropdown-list-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  overflow-y: scroll;
  padding: 1em;
  padding-bottom: 0;
  flex: 1 1;
  height: 100%;
}
.dropdown-list-element {
  background-color: #e4e4e4;
  margin-inline: 0.5em;
  margin-block: 0.1em;
  padding: 0 0.5em;
  border-radius: 3px;
  width: 90%;
}
.dropdown-list-element-text {
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  align-items: center !important;
}
.dropdown-list-subelement {
  width: 80%;
  background-color: #f3f6f9;
  border-radius: 0.2em;
  margin-inline: 0.5em;
  margin-block: 0.1em;
  display: flex;
  justify-content: space-between;
  padding-inline: 1em;
  align-items: center;
  cursor: grab !important;
  cursor: -moz-grab !important;
}
.dropdown-list-subelement-text {
  padding: 0.5em;
}
.dropdown-list-list-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  padding: 0.5em;
}
.dropdown-list-list {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: space-between;
  background-color: #fff;
  border-radius: 1em;
  padding: 1em;
  width: 95%;
}
.dropdown-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-block: 1em;
  flex-wrap: wrap;
}
.dropdown-list-header-main {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;
}
.dropdown-list-header-action, .dropdown-list-header-action:focus, .dropdown-list-header-action:hover, .dropdown-list-header-action:active {
  text-decoration: none;
  outline: none;
  box-shadow: none !important;
  background-color: #fff;
  border: 1px solid #8f003c;
  color: #8f003c;
  padding-inline: 2em;
  border-radius: 8px;
  height: 2em !important;
  line-height: 2em;
  margin-right: 2em;
}
.dropdown-list-header-action:hover {
  background-color: #8f003c;
  color: #fff;
}
.dropdown-list-element {
  flex: 1 1;
  padding: 3px;
  margin-top: 0;
  border-top-right-radius: 0 !important;
  border-top-left-radius: 0 !important;
}
.dropdown-list-element-action {
  font-size: 2em !important;
  color: #777776;
}
.dropdown-list-element-action:hover {
  color: #8f003c;
}
.dropdown-list-element-primary-text {
  color: rgb(255, 252, 252);
}
.dropdown-list-element-secondary-text {
  color: rgb(0, 0, 0);
  align-items: center;
  justify-content: flex-start;
  display: flex;
}
.dropdown-list-element-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.dropdown-list-element {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dropdown-list .button-options {
  border: none;
  background-color: rgba(0, 0, 0, 0);
}
.dropdown-list .button-options-link {
  color: black;
}

.toast-message {
  width: 75vw;
  margin-bottom: 15px;
}

.product {
  background-color: #8f003c;
  border-radius: 1em;
  margin-inline: 0.5em;
  flex: 1 1;
  width: 100%;
  padding: 0.5em;
  border-radius: 3px;
  border-bottom-right-radius: 0;
  color: white;
}

.dropdown-element-secondary-text {
  color: black;
  align-items: center;
  justify-content: center;
  display: flex;
  margin: 0px;
}

.icon-dropdowns {
  margin-right: 10px;
}

.dropdown-element-action {
  cursor: pointer;
  margin: 0.2em;
  border-radius: 2em;
  padding: 0.12em;
  color: rgb(243, 237, 237);
}

.dropdown-element-action:first-child {
  background-color: #3253ad;
}

.dropdown-element-action:nth-child(2) {
  background-color: #8f003c;
}

.dropdown-title {
  font-size: 1.1em;
  font-weight: bold;
  margin-left: 1em;
}

.dropdown-options-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;
}

.dropdown-child {
  width: 70%;
}

.dropdown-child-2 {
  width: 60%;
}

.dropdown-product-badge {
  background-color: white;
  color: black;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 5em;
  padding: 0.2em;
  padding-inline: 1em;
  margin: 0.2em;
}

.grabbable {
  display: flex;
  justify-content: flex-end;
  cursor: default !important;
}

.draggable-container {
  width: 100%;
}

.default-container {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/views/dropdowns/dropdownList/dropdownList.scss","webpack://./src/sass/globals/mixins.scss","webpack://./src/sass/globals/globals.scss"],"names":[],"mappings":"AAGA;ECIC,aAAA;EACA,sBAAA;EACA,2BDLoB;ECMpB,mBDNgC;EAChC,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;AACD;;AAEA;EACC,sBETO;EFUP,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AACD;AACC;ECbA,aAAA;EACA,sBAAA;EACA,8BDYqB;ECXrB,qBDWoC;EACnC,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;AAIF;AADC;EACC,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AAGF;AADE;EACC,wBAAA;EACA,8BAAA;EACA,yCAAA;EACA,8BAAA;AAGH;AACC;EACC,UAAA;EACA,yBE1CK;EF2CL,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,aAAA;EACE,8BAAA;EACA,mBAAA;EACA,mBAAA;EACF,uBAAA;EACA,4BAAA;AACF;AAEC;EACC,cAAA;AAAF;AAGC;ECxDA,aAAA;EACA,sBAAA;EACA,uBDuDqB;ECtDrB,qBDsD6B;EAC5B,WAAA;EACA,cAAA;AAEF;AACC;EC9DA,aAAA;EACA,sBAAA;EACA,8BD6DqB;EC5DrB,0BD4DoC;EACnC,sBEnEM;EFoEN,kBAAA;EACA,YAAA;EACA,UAAA;AAIF;AADC;EC5EA,aAAA;EACA,8BD4Ee;EC3Ef,mBD2E8B;EAC7B,kBAAA;EACA,eAAA;AAKF;AAHE;ECjFD,aAAA;EACA,uBDiFgB;EChFhB,mBDgFwB;EACtB,QAAA;AAOH;AAJE;EAIC,qBAAA;EACA,aAAA;EACA,2BAAA;EACA,sBE1FK;EF2FL,yBAAA;EACA,cEhGQ;EFiGR,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;AAGH;AAAE;EACC,yBEzGQ;EF0GR,WEtGK;AFwGR;AAEC;EACC,SAAA;EACA,YAAA;EACA,aAAA;EACA,qCAAA;EACA,oCAAA;AAAF;AAEE;EACC,yBAAA;EACA,cEhHS;AFgHZ;AAEG;EACC,cE1HO;AF0HX;AAIE;EACC,yBAAA;AAFH;AAIE;EACC,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,aAAA;AAFH;AAKE;ECjID,aAAA;EACA,sBAAA;EACA,uBDgIsB;EC/HtB,uBD+H8B;AAA/B;AA3BC;EC7GA,aAAA;EACA,8BD0Ie;ECzIf,mBDyI8B;AAE/B;AACC;EACC,YAAA;EACA,kCAAA;AACF;AAEC;EACC,YAAA;AAAF;;AAIA;EACC,WAAA;EACA,mBAAA;AADD;;AAIA;EACC,yBE/JU;EFgKV,kBAAA;EACA,oBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;AADD;;AAIA;EACC,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;AADD;;AAIA;EACC,kBAAA;AADD;;AAKA;EACC,eAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAFD;;AAKA;EACC,yBAAA;AAFD;;AAKA;EACC,yBEpMU;AFkMX;;AAKA;EACC,gBAAA;EACA,iBAAA;EACA,gBAAA;AAFD;;AAKA;EACC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AAFD;;AAKA;EACC,UAAA;AAFD;;AAKA;EACC,UAAA;AAFD;;AAKA;EACC,uBAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;AAFD;;AAKA;EACC,aAAA;EACA,yBAAA;EACA,0BAAA;AAFD;;AAKA;EACC,WAAA;AAFD;;AAKA;EACC,WAAA;AAFD","sourcesContent":["@import '../../../../sass/globals/globals.scss';\n@import '../../../../sass/globals/mixins.scss';\n\n.dropdown-main-container {\n\t@include flexColumn(flex-start, center);\n\toverflow-x: hidden;\n\toverflow-y: scroll;\n\tmax-height: 100%;\n\tpadding: 2em;\n\tflex: 1;\n}\n\n.dropdown-list {\n\tbackground-color: $white;\n\tborder-radius: 1em;\n\tmargin-inline: 2em;\n\tpadding: 2em;\n\tflex: 1;\n\twidth: 100%;\n\n\t&-container {\n\t\t@include flexColumn(space-between, flex-end);\n\t\toverflow-y: scroll;\n\t\tpadding: 1em;\n\t\tpadding-bottom: 0;\n\t\tflex: 1;\n\t\theight: 100%;\n\t}\n\n\t&-element {\n\t\tbackground-color: #e4e4e4;\n\t\tmargin-inline: 0.5em;\n\t\tmargin-block: .1em;\n\t\tpadding:  0 0.5em;\n\t\tborder-radius: 3px;\n\t\twidth: 90%;\n\n\t\t&-text{\n\t\t\tdisplay: flex !important;\n\t\t\tflex-direction: row !important;\n\t\t\tjustify-content: space-between !important;\n\t\t\talign-items: center !important;\n\t\t}\n\t}\n\n\t&-subelement {\n\t\twidth: 80%;\t\t\n\t\tbackground-color: $grey;\n\t\tborder-radius: 0.2em;\n\t\tmargin-inline: 0.5em;\n\t\tmargin-block: 0.1em;\n\t\tdisplay: flex;\n    justify-content: space-between;\n    padding-inline: 1em;\n    align-items: center;\n\t\tcursor: grab !important;\n\t\tcursor: -moz-grab !important;\n\t}\n\n\t&-subelement-text {\n\t\tpadding: .5em;\n\t}\n\n\t&-list-container {\n\t\t@include flexColumn(center, flex-end);\n\t\twidth: 100%;\n\t\tpadding: .5em;\n\t}\n\n\t&-list {\n\t\t@include flexColumn(space-between, space-between);\n\t\tbackground-color: $white;\n\t\tborder-radius: 1em;\n\t\tpadding: 1em;\n\t\twidth: 95%;\n\t}\n\n\t&-header {\n\t\t@include flex(space-between, center);\n\t\tpadding-block: 1em;\n\t\tflex-wrap: wrap;\n\n\t\t&-main {\n\t\t\t@include flex(center, center);\n\t\t\tgap: 1em;\n\t\t}\n\n\t\t&-action,\n\t\t&-action:focus,\n\t\t&-action:hover,\n\t\t&-action:active {\n\t\t\ttext-decoration: none;\n\t\t\toutline: none;\n\t\t\tbox-shadow: none !important;\n\t\t\tbackground-color: $white;\n\t\t\tborder: 1px solid $dark-red;\n\t\t\tcolor: $dark-red;\n\t\t\tpadding-inline: 2em;\n\t\t\tborder-radius: 8px;\n\t\t\theight: 2em !important;\n\t\t\tline-height: 2em;\n\t\t\tmargin-right: 2em;\n\t\t}\n\n\t\t&-action:hover {\n\t\t\tbackground-color: $dark-red;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\n\t&-element {\n\t\tflex: 1;\n\t\tpadding: 3px;\n\t\tmargin-top: 0;\n\t\tborder-top-right-radius: 0 !important;\n\t\tborder-top-left-radius: 0 !important;\n\n\t\t&-action {\n\t\t\tfont-size: 2em !important;\n\t\t\tcolor: $dark-grey;\n\n\t\t\t&:hover {\n\t\t\t\tcolor: $dark-red;\n\t\t\t}\n\t\t}\n\n\t\t&-primary-text {\n\t\t\tcolor: rgb(255, 252, 252);\n\t\t}\n\t\t&-secondary-text {\n\t\t\tcolor: rgb(0, 0, 0);\n\t\t\talign-items: center;\n\t\t\tjustify-content: flex-start;\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\t&-text {\n\t\t\t@include flexColumn(center, flex-start);\n\t\t}\n\n\t\t@include flex(space-between, center);\n\t}\n\n\t.button-options{\n\t\tborder: none;\n\t\tbackground-color: rgba(0,0,0,0);\n\t}\n\n\t.button-options-link{\n\t\tcolor: black;\n\t}\n}\n\n.toast-message{\n\twidth: 75vw;\n\tmargin-bottom: 15px;\n}\n\n.product{\n\tbackground-color: $dark-red;\n\tborder-radius: 1em;\n\tmargin-inline: .5em;\n\tflex: 1;\n\twidth: 100%;\n\tpadding: 0.5em;\n\tborder-radius: 3px;\n\tborder-bottom-right-radius: 0;\n\tcolor: white\n}\n\n.dropdown-element-secondary-text{\n\tcolor: black;\n\talign-items: center;\n\tjustify-content: center;\n\tdisplay: flex;\n\tmargin: 0px;\n}\n\n.icon-dropdowns{\n\tmargin-right: 10px;\n\n}\n\n.dropdown-element-action {\n\tcursor: pointer;\n\tmargin: .2em;\n\tborder-radius: 2em;\n\tpadding: .12em;\n\tcolor: rgb(243, 237, 237);\n}\n\n.dropdown-element-action:first-child{\n\tbackground-color: #3253ad;\n}\n\n.dropdown-element-action:nth-child(2){\n\tbackground-color: $dark-red;\n}\n\n.dropdown-title{\n\tfont-size: 1.1em;\n\tfont-weight: bold;\n\tmargin-left: 1em;\n}\n\n.dropdown-options-container {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: flex-end;\n\tflex-direction: column;\n}\n\n.dropdown-child {\n\twidth: 70%;\n}\n\n.dropdown-child-2{\n\twidth: 60%;\n}\n\n.dropdown-product-badge{\n\tbackground-color: white;\n\tcolor: black;\n\tcursor: pointer;\n\tborder: 1px solid transparent;\n\tborder-radius: 5em;\n\tpadding: .2em;\n\tpadding-inline: 1em;\n\tmargin: .2em;\n}\n\n.grabbable {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tcursor: default !important;\n}\n\n.draggable-container {\n\twidth: 100%;\n}\n\n.default-container {\n\twidth: 100%;\n}","@mixin flex($justify-content, $align-items) {\n\tdisplay: flex;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n\n@mixin flexColumn($justify-content, $align-items) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n","$dark-red: #8f003c;\n$sidebar-selected-color: #c4145d;\n$sidebar-logo-color: #a53363;\n$logo-color: #920942;\n$white: #fff;\n$grey: #f3f6f9;\n$grey2: #e2e5e7;\n$dark-grey: #777776;\n$font-color: #fff;\n$shadow-color: #4e7da2;\n$font: 'Rubik';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
